import React, { useEffect, useState } from "react";
import axios from "axios";
import { Table, Button, Modal, Form, Input, Select, message } from "antd";
import { Link } from "react-router-dom";

const { Option } = Select;

const LoadTable = () => {
  const [loads, setLoads] = useState([]);
  const [filteredLoads, setFilteredLoads] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedLoad, setSelectedLoad] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [form] = Form.useForm();
  const [search, setSearch] = useState("");

  useEffect(() => {
    fetchLoads();
  }, []);

  const fetchLoads = async () => {
    setLoading(true);
    try {
      const response = await axios.get("https://servertrucking.vercel.app/api/loads/alloads");
      setLoads(response.data);
      setFilteredLoads(response.data);
    } catch (error) {
      message.error("Failed to fetch loads");
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (record) => {
    setSelectedLoad(record);
    setModalVisible(true);
    form.setFieldsValue(record);
  };

  const handleUpdate = async (values) => {
    try {
      await axios.put(`https://servertrucking.vercel.app/api/loads/update/${selectedLoad._id}`, values);
      message.success("Load updated successfully");
      setModalVisible(false);
      fetchLoads();
    } catch (error) {
      message.error("Failed to update load");
    }
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearch(value);
    if (value) {
      setFilteredLoads(loads.filter(load => load.trackingNumber.includes(value)));
    } else {
      setFilteredLoads(loads);
    }
  };

  const columns = [
    { title: "Tracking ID", dataIndex: "trackingNumber", key: "trackingNumber" },
    { title: "Pickup", dataIndex: "pickupLocation", key: "pickupLocation" },
    { title: "Delivery", dataIndex: "deliveryLocation", key: "deliveryLocation" },
    { title: "Weight (Lbs)", dataIndex: "weight", key: "weight" },
    { title: "Slot Fee Status", dataIndex: "slotFeeStatus", key: "slotFeeStatus" },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Button className="default-btn" onClick={() => handleEdit(record)}>
          Edit
        </Button>
      ),
    },
  ];

  return (
    <div className="container mt-4">
      <h2 className="text-center">All Loads</h2>
<button className="default-btn"><Link to='/form'>Add New Load</Link> </button> <br></br><br></br>
      {/* Search Field */}
      <Input
        placeholder="Search by Tracking ID"
        value={search}
        onChange={handleSearch}
        style={{ marginBottom: 16, width: "50%" }}
      />

      <Table
        dataSource={filteredLoads}
        columns={columns}
        rowKey="_id"
        loading={loading}
        bordered
      />

      {/* Edit Modal */}
      <Modal
        title="Edit Load Details"
        open={modalVisible}
        onCancel={() => setModalVisible(false)}
        footer={null}
      >
        <Form form={form} onFinish={handleUpdate} layout="vertical">
          <Form.Item name="pickupLocation" label="Pickup Location">
            <Input />
          </Form.Item>
          <Form.Item name="pickupTime" label="Pickup Time">
            <Input />
          </Form.Item>
          <Form.Item name="deliveryLocation" label="Delivery Location">
            <Input />
          </Form.Item>
          <Form.Item name="deliveryTime" label="Delivery Time">
            <Input />
          </Form.Item>
          <Form.Item name="weight" label="Weight (Lbs)">
            <Input type="number" />
          </Form.Item>
          <Form.Item name="backhaulWeight" label="Backhaul Weight">
            <Input type="number" />
          </Form.Item>
          <Form.Item name="paying" label="Paying">
            <Input type="number" />
          </Form.Item>
          <Form.Item name="roundTrips" label="Round Trips">
            <Input type="number" />
          </Form.Item>
          <Form.Item name="slotFeeStatus" label="Slot Fee Status">
            <Select>
              <Option value="Pending">Pending</Option>
              <Option value="Shipped">Paid</Option>
              {/* <Option value="Dispatched">Dispatched</Option>
              <Option value="Delivered">Delivered</Option> */}
            </Select>
          </Form.Item>
          <Form.Item name="trackingNumber" label="Tracking Number">
            <Input disabled />
          </Form.Item>
          <Button  className="default-btn" htmlType="submit" block>
            Update
          </Button>
        </Form>
      </Modal>
    </div>
  );
};

export default LoadTable;
